<template>
  <div>
    <div class="dnssec">
      <div class="title">
        <h2>{{name}}部署情况</h2>
      </div>
      <div class="box" id="box" ref="box">
      </div>
    </div>
  </div>
</template>
<script>
import {getDNSSEC} from "@/service/dashboard";

export default {
  data() {
    return {
      name: "",
      cnData:[0.40,0.50,1.43,0.77,0.80],
      usData:[0.50,0.60,1.39,0.70,0.71],
      date:["5-13","5-15","5-17","5-19","5-21"],
      option : {
        tooltip: { trigger: "axis" },
        legend: {
          orient: "vertical", // 图例的布局朝向，'vertical' 表示垂直
          right: 0,          // 图例距离容器右侧的距离
          bottom: 40,         // 图例距离容器底部的距离
          itemWidth: 10,        // 图例图标的宽度
          itemHeight: 10,       // 图例图标的高度，与宽度相同以创建正方形
          icon: "rect",         // 图例图标类型为 'rect'（矩形）
          itemGap: 10,          // 图例项之间的间隔
          data: ["中","美"],
          textStyle:{
            color:"rgba(241, 237, 255, 1)"
          }
        },
        grid: {
          top: "10%",
          bottom: "0%",
          left: "0%",
          right: "12%",
          containLabel: true
        },
        xAxis:{
          type:"category",
          data:["5-13","5-15","5-17","5-19","5-21"],
          //两边贴紧边缘
          boundaryGap:false,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "rgba(255, 255, 255, 1)",
            fontSize: 10
            // rotate:30
            // margin: 10,
          },
          splitLine: {
            show: false
          }
        },
        yAxis:{
          type:"value",
          scale:true,
          //y轴起点不为0  当data的数据过于相近的时候
          // interval: 0.5,
          // max: 2,
          // min: 0,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(184, 211, 241, 1)",
              opacity: 0.15
            }
          },
          axisLabel: {
            color: "rgba(184, 211, 241, 1)",
            fontSize: 12,
            margin: 5
          }

        },
        series:[
          {
            name:"美",
            type:"line",  //bar 柱状图 line 折线图
            // z: 3, //显不显示点
            // showSymbol: false,
            //点的样式 颜色 大小
            symbol: "circle",
            color: "#00F6FF",
            symbolSize: 4,
            itemStyle: {
              borderWidth: 6,
              borderColor: "#00F6FF"
            },
            data:[0.50,0.60,1.39,0.70,0.71],
            //折线样式
            lineStyle: {
              width: 3,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: "rgba(163, 124, 245, 1)" // 0% 处的颜色
                },
                {
                  offset: 0.5, color: "rgba(35, 109, 252, 1)" // 50% 处的颜色
                },
                {
                  offset: 0.8, color: "rgba(28, 243, 230, 1)" // 50% 处的颜色
                },
                {
                  offset: 1, color: "rgba(246, 186, 97, 1)" // 100% 处的颜色
                }]
              },
              shadowBlur: 4,
              shadowColor: "rgba(6,126,247,.2)",
              shadowOffsetY: 4
            },
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: "rgba(90, 100, 191, 1)" // 0% 处的颜色
                  }, {
                    offset: 1, color: "rgba(0, 121, 135, 0.122)" // 100% 处的颜色
                  }]
                }
              }
            }
            // smooth: true, //平滑曲线
          },
          {
            name:"中",
            type:"line",  //bar 柱状图 line 折线图
            // z: 3, //显不显示点
            // showSymbol: false,
            //点的样式 颜色 大小
            symbol: "circle",
            color: "#3f93f3",
            symbolSize: 4,
            itemStyle: {
              borderWidth: 6,
              borderColor: "#3f93f3"
            },
            data:[0.40,0.50,1.43,0.77,0.80],
            // stack:"aa",  //堆叠图 只要每个图片 有相同的stack 数据就能堆叠到一起
            //折线样式
            lineStyle: {
              width: 3,
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0, color: "rgba(130, 135, 247, 1)" // 0% 处的颜色
                }, {
                  offset: 0.85, color: "rgba(0, 246, 255, 1)" // 50% 处的颜色
                }, {
                  offset: 1, color: "rgba(255, 227, 92, 1)" // 100% 处的颜色
                }]
              },
              shadowBlur: 4,
              shadowColor: "rgba(69,126,247,.2)",
              shadowOffsetY: 4
            },
            areaStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0, color: "rgba(0, 211, 255, 1)" // 0% 处的颜色
                  }, {
                    offset: 1, color: "rgba(0, 121, 135, 0.122)" // 100% 处的颜色
                  }]
                }
              }
            }
            // smooth: true, //平滑曲线
          }

        ]

      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(){
      getDNSSEC().then(res => {
        this.name = res.name;
        this.option.series[1].data = res.data.map(item => item.cn*100);
        this.option.series[0].data = res.data.map(item => item.us*100);
        // this.date = res.data.map(item => item.date);
        this.date = [];
        // 遍历原始数据数组
        res.data.forEach(item => {
          // 提取月和日部分，并格式化为 "MM-DD"
          let formattedDate = item.date.substring(4, 6) + "-" + item.date.substring(6, 8);
          // 将格式化后的日期字符串添加到新数组中

          this.date.push(formattedDate);
        });
        this.option.xAxis.data = this.date;
        this.getBar();
      });
      //获取柱状图
    },
    getBar() {
      //let ec = this.$echarts.init(document.getElementById('box'))
      let ec = this.$echarts.init(this.$refs.box);
      // let option = {
      //   tooltip: { trigger: 'axis' },
      //   legend: {
      //     orient: 'vertical', // 图例的布局朝向，'vertical' 表示垂直
      //     right: 0,          // 图例距离容器右侧的距离
      //     bottom: 40,         // 图例距离容器底部的距离
      //     itemWidth: 10,        // 图例图标的宽度
      //     itemHeight: 10,       // 图例图标的高度，与宽度相同以创建正方形
      //     icon: 'rect',         // 图例图标类型为 'rect'（矩形）
      //     itemGap: 10,          // 图例项之间的间隔
      //     data: ["中","美"],
      //     textStyle:{
      //       color:"rgba(241, 237, 255, 1)"
      //     }
      //   },
      //   grid: {
      //     top: '10%',
      //     bottom: '0%',
      //     left: '0%',
      //     right: '12%',
      //     containLabel: true
      //   },
      //   xAxis:{
      //     type:"category",
      //     data:this.date,
      //     //两边贴紧边缘
      //     boundaryGap:false,
      //     axisLine: {
      //       show: false
      //     },
      //     axisTick: {
      //       show: false
      //     },
      //     axisLabel: {
      //       color: 'rgba(255, 255, 255, 1)',
      //       fontSize: 10,
      //       rotate:30
      //       // margin: 10,
      //     },
      //     splitLine: {
      //       show: false
      //     }
      //   },
      //   yAxis:{
      //     type:"value",
      //     //y轴起点不为0  当data的数据过于相近的时候
      //     interval: 0.5,
      //     max: 2,
      //     // min: 0,
      //     axisTick: {
      //       show: false
      //     },
      //     axisLine: {
      //       show: false
      //     },
      //     splitLine: {
      //       show: true,
      //       lineStyle: {
      //         color: 'rgba(184, 211, 241, 1)',
      //         opacity: .15
      //       }
      //     },
      //     axisLabel: {
      //       color: 'rgba(184, 211, 241, 1)',
      //       fontSize: 12,
      //       margin: 5,
      //     },
      //
      //   },
      //   series:[
      //     {
      //       name:"美",
      //       type:"line",  //bar 柱状图 line 折线图
      //       // z: 3, //显不显示点
      //       // showSymbol: false,
      //       //点的样式 颜色 大小
      //       symbol: 'circle',
      //       color: 'rgba(132, 137, 255, 1)',
      //       symbolSize: 4,
      //       itemStyle: {
      //         borderWidth: 6,
      //         borderColor: 'rgba(132, 137, 255, 1)',
      //       },
      //       data:this.usData,
      //       //折线样式
      //       lineStyle: {
      //         width: 3,
      //         color: {
      //           type: 'linear',
      //           x: 0,
      //           y: 0,
      //           x2: 0,
      //           y2: 1,
      //           colorStops: [{
      //             offset: 0, color: 'rgba(163, 124, 245, 1)' // 0% 处的颜色
      //           },
      //             {
      //               offset: 0.5, color: 'rgba(35, 109, 252, 1)' // 50% 处的颜色
      //             },
      //             {
      //               offset: 0.8, color: 'rgba(28, 243, 230, 1)' // 50% 处的颜色
      //             },
      //             {
      //               offset: 1, color: 'rgba(246, 186, 97, 1)' // 100% 处的颜色
      //             }]
      //         },
      //         shadowBlur: 4,
      //         shadowColor: 'rgba(6,126,247,.2)',
      //         shadowOffsetY: 4
      //       },
      //       areaStyle: {
      //         normal: {
      //           color: {
      //             type: 'linear',
      //             x: 0,
      //             y: 0,
      //             x2: 0,
      //             y2: 1,
      //             colorStops: [{
      //               offset: 0, color: 'rgba(90, 100, 191, 1)' // 0% 处的颜色
      //             }, {
      //               offset: 1, color: 'rgba(0, 121, 135, 0.122)' // 100% 处的颜色
      //             }]
      //           }
      //         }
      //       },
      //       // smooth: true, //平滑曲线
      //     },
      //     {
      //       name:"中",
      //       type:"line",  //bar 柱状图 line 折线图
      //       // z: 3, //显不显示点
      //       // showSymbol: false,
      //       //点的样式 颜色 大小
      //       symbol: 'circle',
      //       color: 'rgba(0, 246, 255, 1)',
      //       symbolSize: 4,
      //       itemStyle: {
      //         borderWidth: 6,
      //         borderColor: 'rgba(0, 246, 255, 1)',
      //       },
      //       data:this.cnData,
      //       // stack:"aa",  //堆叠图 只要每个图片 有相同的stack 数据就能堆叠到一起
      //       //折线样式
      //       lineStyle: {
      //         width: 3,
      //         color: {
      //           type: 'linear',
      //           x: 0,
      //           y: 0,
      //           x2: 0,
      //           y2: 1,
      //           colorStops: [{
      //             offset: 0, color: 'rgba(130, 135, 247, 1)' // 0% 处的颜色
      //           }, {
      //             offset: 0.85, color: 'rgba(0, 246, 255, 1)' // 50% 处的颜色
      //           }, {
      //             offset: 1, color: 'rgba(255, 227, 92, 1)' // 100% 处的颜色
      //           }]
      //         },
      //         shadowBlur: 4,
      //         shadowColor: 'rgba(69,126,247,.2)',
      //         shadowOffsetY: 4
      //       },
      //       areaStyle: {
      //         normal: {
      //           color: {
      //             type: 'linear',
      //             x: 0,
      //             y: 0,
      //             x2: 0,
      //             y2: 1,
      //             colorStops: [{
      //               offset: 0, color: 'rgba(0, 211, 255, 1)' // 0% 处的颜色
      //             }, {
      //               offset: 1, color: 'rgba(0, 121, 135, 0.122)' // 100% 处的颜色
      //             }]
      //           }
      //         }
      //       },
      //       // smooth: true, //平滑曲线
      //     }
      //
      //   ]
      //
      // }

      ec.setOption(this.option);
      // console.log(this.option);
      window.onresize = () => {
        setTimeout(() => {
          const width = this.$refs.box.offsetWidth;
          const height = this.$refs.box.offsetHeight;

          ec.resize({
            width: width,
            height: height
          });
        }, 500);
      };
    }
  }
};


</script>
<style scoped lang="less">
.dnssec{
  background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
  width: 430px;
  height: 247px;
  border-radius: 10px;
  padding-top: 10px;
  padding-left: 35px;
  box-sizing: border-box;
  h2{
    color: rgba(241, 237, 255, 1);
    font-family: 'YouSheBiaoTiHei';
    font-size: 24px;
    height: 31px;
    text-align: left;
    text-shadow: 0 2px 20px rgba(42, 56, 180, 1) ;
  }
}
.box {
  width: 390px;
  height: 190px;
}
</style>